import { http } from "api/apiConfig";
import { baseurl } from "constants/endpoints";
export const fetchReplacementList = async (agreementId, agreementDetailId) => {
    const { data } = await http.get(`${baseurl}/products/${agreementId}/update/${agreementDetailId}/replacement_list`);
    return data;
};
export const updateProducts = async (payload) => {
    return await http.post(`${baseurl}/products/${payload.agreementId}/update`, {
        actions: payload.data,
    });
};
